export default __webpack_public_path__ + "static/media/white-dot.e846589e.svg";